import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "ui/components/sheet";
import {
  FormField,
  FormItem,
  FormMessage,
} from "ui/components/form";
import { Button } from "ui/components/button";
import { Form } from "react-crud-form";
import { FormLabel } from "components/form";
import { useForm } from "react-hook-form";
import React, { useEffect } from "react";
import ToolCombobox from "components/directus/combobox/tool";
import { useParams } from "react-router-dom";
import { useCreateTool } from "./mutation";
import SelectType from "components/select/type";

export default function CreateToolDialog({
  open,
  onOpenChange,
}) {
  const form = useForm({
    defaultValues: {
      type: undefined,
      tool: undefined,
    },
  });

  const selectedType = form.watch("type");
  const { setValue } = form;

  // Reset tool when type changes
  useEffect(() => {
    if (selectedType) {
      setValue("tool", undefined);
    }
  }, [selectedType, setValue]);
  const { casestudyId } = useParams();
  const createToolMutation = useCreateTool({
    casestudyId,
    onSuccess: () => {
      onOpenChange(false);
    }
  });

  async function handleCreate(context) {
    const values = context.values;
    await createToolMutation.mutateAsync({
      item: {
        ...values,
        case_study: casestudyId,
      }
    });
    form.reset();
  }

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent>
        <SheetHeader>
          <SheetTitle>Add</SheetTitle>
        </SheetHeader>
        <Form
          form={form}
          create={handleCreate}
          itemId="+"
        >
          {({ isCreating, createItem, isDirty }) => (
            <div className="grid gap-4">

              {/* Type */}
              <div className="px-4">
                <FormField
                  control={form.control}
                  name="type"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>Type</FormLabel>
                      <SelectType
                        collection="tools"
                        fetchItems={true}
                        onValueChange={val => field.onChange(val)}
                        {...field}
                      />
                      <FormMessage />
                    </FormItem>
                  )}
                />
              </div>

              {/* Tool */}
              <div className="px-4">
                <FormField
                  control={form.control}
                  name="tool"
                  render={({ field }) => (
                    <FormItem>
                      <ToolCombobox
                        filter={selectedType ? { type: { _eq: selectedType } } : {}}
                        disabled={!selectedType}
                        onValueChange={val => field.onChange(val)}
                        {...field}
                      />
                      <FormMessage />
                    </FormItem>
                  )}
                />
              </div>

              <div className="flex justify-end px-4">
                <Button
                  type="button"
                  onClick={createItem}
                  disabled={!isDirty || isCreating}
                  loading={isCreating}
                >
                  Add
                </Button>
              </div>
            </div>
          )}
        </Form>
      </SheetContent>
    </Sheet>
  );
}